/*
 * @Author: yang.chen yang.chen
 * @Date: 2024-07-05 16:43:43
 * @LastEditors: yang.chen yang.chen
 * @LastEditTime: 2024-11-07 17:23:49
 * @FilePath: /jsweb/src/api/api.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
// 引入 axios
import axios from "axios";
import { encode } from 'base-64'

const instance = axios.create({
    baseURL: '/',
    timeout: 10000
});
let token = ''
instance.interceptors.request.use(config => {
    config.headers['SadpAuthorization'] = 'Bearer ' + encode('3ea361dca4bb91b98ff083e121485649:0ca9162bbcdcc943d24b0c0977be6873')
    if (token) {
      config.headers['AccessToken'] = token;
    }
    return config;
})

instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response) {
        console.error('响应拦截器捕获到错误:', error.response.data, error.response.status, error.response.headers);
      } else {
        console.error('网络错误:', error.message);
      }
      return Promise.resolve(error);
    }
  );

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return instance({
        method:'get',
        url:`${url}`,
        data: params,
    })
}

export const getInfo=(params)=>{
    return instance({
        method:'post',
        url:`/prod-api/gateway/secret/getToken`,
        data: params,
    }).then(res=> {
        console.log(res);
        token = res.data.data.access_token
    })
}

export const submitData=(data)=>{
    return instance({
        method:'post',
        url:`/prod-api/api/testapply`,
        data: data,
    })
}

export const submitQuestion=(data)=>{
  return instance({
      method:'post',
      url:`/prod-api/api/insertmessage`,
      data: data,
  })
}
